
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/2015-12-15-mile",
      function () {
        return require("private-next-pages/posts/2015-12-15-mile.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/2015-12-15-mile"])
      });
    }
  